import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';
import { ClientEnvironment, EndpointsConfig } from '../models/endpoints-config';
import { environment } from '../../../environments/environment';
import { CLIENT_ENV_AUTH } from 'mock-auth/client-env';
import { AUTH_SERVICE } from 'src/app/auth/auth.token';
import { IAuthService } from 'src/app/auth/auth.types';


@Injectable()
export class EndpointsConfigService {
    private config: ClientEnvironment = {} as ClientEnvironment;

    private _apiFallback: boolean = false;
    get apiFallback(): boolean {
        return this._apiFallback;
    }
    set apiFallback(value: boolean) {
        this._apiFallback = value;
    }

    constructor(private readonly http: HttpClient,
        @Inject(AUTH_SERVICE) private authService: IAuthService,
    ) {
    }

    getClientEnvironmentConfig(): Observable<ClientEnvironment> {
        if (environment?.mockAuth) {
            return of(CLIENT_ENV_AUTH);
        }
        else {
            return this.http.get<ClientEnvironment>(`${this.authService.identityServerEndpoint}/api/client/env`)
                .pipe(
                    tap(config => this.config = config)
                );
        }
    }

    getEndpointsConfig(): EndpointsConfig {
        return this.getEndpointsConfigWithFallback(this._apiFallback);
    }

    getEndpointsConfigWithFallback(apiFallback: boolean): EndpointsConfig {
        const { portalApiUrl, coreUiUrl, sharedUiUrl } = this.config;
        let config = {
            identityServerEndpoint: this.authService.identityServerEndpoint,
            webApiServerEndpoint: portalApiUrl ?? environment.webApiServerEndpoint,
            quantiumCoreHostname: coreUiUrl ?? environment.quantiumCoreHostname,
            quantiumSharedHostname: sharedUiUrl ?? environment.quantiumSharedHostname,
            azureFunctionEndpoint: environment.azureFunctionEndpoint
        };

        if (apiFallback) {
            const fallbackEndpoint = environment.fallbackEndpoint(config.webApiServerEndpoint);
            if (fallbackEndpoint) {
                config.webApiServerEndpoint = fallbackEndpoint;
            }
        }

        return config;
    }
}
